import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/ui/primitives';
import { FilterOutlined, ClearOutlined, DownOutlined, UpOutlined } from '@/shared/ui/icons';

interface FilterPanelProps {
  onReset: () => void;
  children: ReactNode;
  defaultOpen?: boolean;
}

export default function FilterPanel({ onReset, children, defaultOpen = false }: FilterPanelProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <Button
          icon={<FilterOutlined />}
          onClick={() => setOpen((v) => !v)}
          type={open ? 'primary' : 'default'}
          iconPosition="start"
        >
          <span>{t('common.filters')}</span>
          <span style={{ marginInlineStart: 4, opacity: 0.7, fontSize: 11 }}>
            {open ? <UpOutlined /> : <DownOutlined />}
          </span>
        </Button>
        {open && (
          <Button icon={<ClearOutlined />} onClick={onReset} size="small" type="text">
            {t('common.resetFilters')}
          </Button>
        )}
      </div>

      {open && (
        <div
          style={{
            marginTop: 12,
            padding: '16px 18px',
            background: 'var(--bg-card)',
            borderRadius: 'var(--r-xl)',
            border: '1px solid var(--grey-200)',
            boxShadow: 'var(--shadow-xs)',
            display: 'flex',
            flexWrap: 'wrap',
            gap: 14,
            alignItems: 'flex-end',
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
